"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _bwcOrder = require("@/api/selfOfficialOrder/bwcOrder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OfficialOrder',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 20,
      queryData: {
        orderNo: '',
        mobile: '',
        orderStatus: '',
        appId: '',
        userId: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    onInquire: function onInquire() {
      this.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.queryData = {
        orderNo: '',
        mobile: '',
        orderStatus: '',
        appId: '',
        userId: ''
      };
      this.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this = this;
        var params, queryKeys, res, data, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              params = {
                page: this.page,
                size: this.size,
                sourceType: 2
              };
              queryKeys = ['orderNo', 'mobile', 'orderStatus', 'appId', 'userId'];
              queryKeys.forEach(function (key) {
                if (_this.queryData[key] !== '' && _this.queryData[key] !== null && _this.queryData[key] !== undefined) {
                  params[key] = _this.queryData[key];
                }
              });
              _context.n = 2;
              return (0, _bwcOrder.queryBwcOrderPage)(params);
            case 2:
              res = _context.v;
              data = res.data || {};
              this.tableData = data.data || [];
              this.total = data.total || 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('查询霸王餐订单失败', _t);
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    formatPlatform: function formatPlatform(code) {
      var map = {
        ele: '淘宝闪购',
        mt: '美团',
        jd: '京东外卖'
      };
      return map[code] || code || '-';
    },
    formatSourceType: function formatSourceType(type) {
      var map = {
        1: '自营',
        2: '官方'
      };
      return map[type] || type || '-';
    },
    formatOrderStatus: function formatOrderStatus(status) {
      var map = {
        '-6': '不满意通过',
        '-3': '已驳回',
        '-1': '已取消',
        0: '已报名',
        1: '已提交',
        2: '待审核',
        3: '已完成'
      };
      return map[status] || status || '-';
    },
    statusType: function statusType(status) {
      var typeMap = {
        '-6': 'success',
        '-3': 'danger',
        '-1': 'info',
        0: '',
        1: 'warning',
        2: 'warning',
        3: 'success'
      };
      return typeMap[status] || '';
    },
    formatPraiseType: function formatPraiseType(type) {
      var map = {
        0: '用餐反馈',
        1: '图文反馈',
        2: '无需反馈',
        3: '免提交'
      };
      return map[type] || type || '-';
    },
    toDetail: function toDetail(row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          appId: row.appId,
          memberId: row.memberId,
          orderNo: row.orderNo
        }
      });
    }
  }
};